module.exports = __webpack_public_path__ + "media/images/icons/digging-85ab3e40948da7c3285223d7c1f5e192.svg";